import { useState } from "react";
import { Card, Checkbox, Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { authActions, authCRUD } from "../../../actions/auth";
import { char } from "../../../utils";

const loginSchema = Yup.object().shape({
  username: Yup.string().required("Email is required"),
  password: Yup.string().required("Password is required"),
});

const initialValues = {
  username: "",
  password: "",
};

export const LoginContent = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  let navigate = useNavigate();

   const formik = useFormik({
     initialValues,
     validationSchema: loginSchema,
     onSubmit: (values, { setStatus, setSubmitting }) => {
       setLoading(true);
       setTimeout(() => {
         const user = { username: values.username, password: values.password };
         authCRUD
           .loadUser(values.username)
           .then((resp) => {
             setLoading(false);
             if (!resp.data.is_active) {
               setStatus("The login detail is incorrect");
             } else {
               dispatch(authActions.getUser(resp.data));
               authCRUD
                 .loadToken(user)
                 .then((resp) => {
                   dispatch(authActions.setAuth(true));
                   dispatch(authActions.setLock(null));
                   dispatch(authActions.getToken(resp.data));
                   navigate("/home");
                   setLoading(false);
                 })
                 .catch((error) => {
                   if (error) {
                     setLoading(false);
                     setSubmitting(false);
                     setStatus("The login detail is incorrect");
                   }
                 });
             }
           })
           .catch(() => {
             setLoading(false);
             setSubmitting(false);
             setStatus("The login detail is incorrect");
           });
       }, 1000);
     },
   });

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4 position-absolute top-50 start-50 translate-middle">
            <Card bordered={false}>
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-12 text-center">
                      <img
                        width={150}
                        className="mt-0 mb-2"
                        src="assets/images/logo/logo.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <p className="text-center h3 fw-bold mt-3">
                        ARDHI UNIVERSITY
                      </p>
                      <p className="text-center h4 fw-bold mt-3">
                        {char.toLowerCase("ARDHI IDENTITY CARD PORTAL")}
                      </p>
                      {formik.status ? (
                        <div className="alert alert-danger mt-3">
                          <div className="alert-text fw-light text-center">
                            {formik.status}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <hr />
                      <form onSubmit={formik.handleSubmit}>
                        <div className="row ms-5 me-5">
                          <div className="col-12">
                            <div className="form-group">
                              <label className="form-label fw-bold">
                                Username
                                <span className="ms-2 text-danger">*</span>
                              </label>
                              <Input
                                size="large"
                                placeholder="Username"
                                {...formik.getFieldProps("username")}
                                status={
                                  formik.touched.username &&
                                  formik.errors.username &&
                                  "error"
                                }
                              />
                              {formik.touched.username &&
                                formik.errors.username && (
                                  <div
                                    className="fw-light mt-1"
                                    style={{ fontSize: "15px" }}
                                  >
                                    <span role="alert" className="text-danger">
                                      {formik.errors.username}
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="row ms-5 me-5 mt-3">
                          <div className="col-12">
                            <div className="form-group">
                              <label className="form-label fw-bold">
                                Password
                                <span className="ms-2 text-danger">*</span>
                              </label>
                              <Input.Password
                                iconRender={(visible) =>
                                  visible ? (
                                    <EyeTwoTone />
                                  ) : (
                                    <EyeInvisibleOutlined />
                                  )
                                }
                                size="large"
                                placeholder="Password"
                                {...formik.getFieldProps("password")}
                                status={
                                  formik.touched.password &&
                                  formik.errors.password &&
                                  "error"
                                }
                              />
                              {formik.touched.password &&
                                formik.errors.password && (
                                  <div
                                    className="fw-light mt-1"
                                    style={{ fontSize: "15px" }}
                                  >
                                    <span role="alert" className="text-danger">
                                      {formik.errors.password}
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="row ms-5 me-5 mt-3">
                          <div className="col-md-6">
                            <Checkbox>Remember me</Checkbox>
                          </div>
                          <div className="col-md-6 text-end">
                            <Link to={"/home"}>Forget Password</Link>
                          </div>
                        </div>
                        <div className="row ms-5 me-5 mt-3">
                          <div className="col-12">
                            <button
                              type="submit"
                              className="btn btn-primary waves-effect waves-light w-100"
                              disabled={formik.isSubmitting || !formik.isValid}
                            >
                              {!loading ? (
                                <span className="indicator-label">
                                  <span className="bi bi-box-arrow-in-right"></span>{" "}
                                  Login
                                </span>
                              ) : (
                                <span
                                  className="indicator-progress"
                                  style={{ display: "block" }}
                                >
                                  Please wait.....
                                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="row mt-5">
                          <div className="col-12 text-center">
                            <p className="mb-0">
                              © {new Date().getFullYear()} &nbsp;{" "}
                              <span className="fw-bold h6 text-primary">
                                aru
                              </span>
                            </p>
                            <p className="fw-light h6 text-warning fs-11 fst-italic mt-2">
                              {" "}
                              ---- weledi na ustawi ----
                            </p>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-md-4"></div>
        </div>
      </div>
    </>
  );
};
